import { render, staticRenderFns } from "./jingQuRenShu.vue?vue&type=template&id=f4153f9c&scoped=true&"
import script from "./jingQuRenShu.vue?vue&type=script&lang=js&"
export * from "./jingQuRenShu.vue?vue&type=script&lang=js&"
import style0 from "./jingQuRenShu.vue?vue&type=style&index=0&id=f4153f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4153f9c",
  null
  
)

export default component.exports